import PropTypes from 'prop-types';
import React from 'react';
// NK
import { useNkStyles } from '../../infrastructure/theme';
// Material UI
import Typography from '@material-ui/core/Typography';
// Devexpress
import PieChart, {
  Legend,
  Series,
  Tooltip,
  Format,
  Label,
  Connector,
} from 'devextreme-react/pie-chart';

type NkDoughnutType = 'donut' | 'doughnut' | 'pie';
type PaletteType =
  | 'Bright'
  | 'Harmony Light'
  | 'Ocean'
  | 'Pastel'
  | 'Soft'
  | 'Soft Pastel'
  | 'Vintage'
  | 'Violet'
  | 'Carmine'
  | 'Dark Moon'
  | 'Dark Violet'
  | 'Green Mist'
  | 'Soft Blue'
  | 'Material'
  | 'Office';

interface NkDoughnutProps {
  type: NkDoughnutType;
  title: string;
  subTitle: string;
  dataSource: Array<any>;
  argumentField: string;
  format: string;
  horizontalAlignment: string;
  verticalAlignment: string;
  palette: PaletteType;
  fullWidth?: boolean;
  wrapperStyle?: React.CSSProperties;
  id: string;
}

const NkDoughnut = (props: NkDoughnutProps) => {
  const classes = useNkStyles();

  const customizeTooltip = (arg: any) => {
    return {
      text: `${arg.valueText} - ${(arg.percent * 100).toFixed(2)}%`,
    };
  };

  return (
    <div style={props.wrapperStyle}>
      <div className="component">
        <Typography color="inherit" variant="h6">
          {props.title}
        </Typography>
        <Typography color="inherit" variant="h4">
          {props.subTitle}
        </Typography>
        <PieChart
          id={props.id}
          palette={props.palette}
          type={props.type}
          dataSource={props.dataSource}
        >
          <Series argumentField="name">
            <Label visible={true} format={props.format}>
              <Connector visible={true} />
            </Label>
          </Series>
          <Legend
            margin={0}
            horizontalAlignment={props.horizontalAlignment}
            verticalAlignment={props.horizontalAlignment}
          />
          <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
            <Format type={props.format} />
          </Tooltip>
        </PieChart>
      </div>
    </div>
  );
};

NkDoughnut.propTypes = {
  type: PropTypes.oneOf(['donut', 'doughnut', 'pie']),
  subTitle: PropTypes.string,
  title: PropTypes.string,
  palette: PropTypes.oneOf([
    'Bright',
    'Harmony Light',
    'Ocean',
    'Pastel',
    'Soft',
    'Soft Pastel',
    'Vintage',
    'Violet',
    'Carmine',
    'Dark Moon',
    'Dark Violet',
    'Green Mist',
    'Soft Blue',
    'Material',
    'Office',
  ]),
  dataSource: PropTypes.array.isRequired,
  argumentField: PropTypes.string,
  format: PropTypes.oneOf([
    'billions',
    'currency',
    'day',
    'decimal',
    'exponential',
    'fixedPoint',
    'largeNumber',
    'longDate',
    'longTime',
    'millions',
    'millisecond',
    'month',
    'monthAndDay',
    'monthAndYear',
    'percent',
    'quarter',
    'quarterAndYear',
    'shortDate',
    'shortTime',
    'thousands',
    'trillions',
    'year',
    'dayOfWeek',
    'hour',
    'longDateLongTime',
    'minute',
    'second',
    'shortDateShortTime',
  ]),
  horizontalAlignment: PropTypes.oneOf(['right', 'left']),
  verticalAlignment: PropTypes.oneOf(['top', 'bottom']),
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  wrapper: PropTypes.bool,
  wrapperStyle: PropTypes.object,
};

export default React.memo(NkDoughnut);
